module.exports = __webpack_public_path__ + "img/baseball_protective.758dd219.svg";